import * as React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import Table from "@amzn/awsui-components-react/polaris/table";
import Flashbar from "@amzn/awsui-components-react/polaris/flashbar";
import Spinner from "@amzn/awsui-components-react/polaris/spinner";
import CopyToClipboard from "@amzn/awsui-components-react/polaris/copy-to-clipboard";

import Button from "@amzn/awsui-components-react/polaris/button";

export interface UcsOverride {
  overrideId: string;
  status: string;
  overrideReason: string;
  createdDate: number;
  expiryDate?: number;
  orderId?: string;
  approvalId?: string;
}

interface Props {
  overrides: UcsOverride[];
  isLoading: boolean;
  onRefresh: () => void;
  drugAsin: string;
}

const copyCell = (value: string | number | undefined): React.ReactNode => {
  if (!value && value !== 0) return "-";
  const text = String(value);
  return (
    <CopyToClipboard
      copyButtonAriaLabel={`Copy ${text}`}
      copySuccessText="Copied"
      copyErrorText="Failed to copy"
      textToCopy={text}
      variant="inline"
    />
  );
};

class OverridesTable extends React.Component<Props> {
  render() {
    const { overrides, isLoading, onRefresh, drugAsin } = this.props;

    const headerWithRefresh = (count?: number) => (
      <Header
        variant="h3"
        actions={<Button iconName="refresh" variant="icon" onClick={onRefresh} loading={isLoading} />}
      >
        Existing Overrides - {drugAsin}{count !== undefined ? ` (${count})` : ""}
      </Header>
    );

    if (isLoading) {
      return (
        <Container header={headerWithRefresh()}>
          <Spinner size="large" />
        </Container>
      );
    }

    if (overrides.length === 0) {
      return (
        <Container header={headerWithRefresh()}>
          <Flashbar items={[{
            type: "info",
            content: "No existing overrides found for this drug.",
          }]} />
        </Container>
      );
    }

    return (
      <Container header={headerWithRefresh(overrides.length)}>
        <Table
          items={overrides}
          columnDefinitions={[
            { id: "overrideId", header: "Override ID", cell: (item) => copyCell(item.overrideId) },
            { id: "status", header: "Status", cell: (item) => copyCell(item.status) },
            { id: "overrideReason", header: "Reason", cell: (item) => copyCell(item.overrideReason) },
            { id: "createdDate", header: "Created", cell: (item) => copyCell(item.createdDate) },
            { id: "expiryDate", header: "Expiry", cell: (item) => copyCell(item.expiryDate) },
            { id: "orderId", header: "Order ID", cell: (item) => copyCell(item.orderId) },
            { id: "approvalId", header: "Approval ID", cell: (item) => copyCell(item.approvalId) },
          ]}
          variant="embedded"
          empty="No overrides"
        />
      </Container>
    );
  }
}

export default OverridesTable;
